export default {
  methods: {
    formatDate: (ts, format = 'YYYY-mm-dd hh:ii:ss') => {
      const exp = /[Ymdhis]+/g;
      const date = new Date(ts);
      const map = {
        Y: String(date.getFullYear()),
        m: '00' + (date.getMonth() + 1),
        d: '00' + date.getDate(),
        h: '00' + date.getHours(),
        i: '00' + date.getMinutes(),
        s: '00' + date.getSeconds(),
      };
      return format.replace(exp, match => {
        const val = map[ match[ 0 ] ];
        return val.substring(val.length - match.length);
      });
    }
  }
};